module.exports = __webpack_public_path__ + "78ac069f5656e5edc0b96674dca968a6.png";